import styled from "@emotion/styled";
import { faCheckCircle, faTrashAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IOButton from "../../../../UI/Form/Button/IOButton";
import { faPencil, faPlay } from "@fortawesome/pro-light-svg-icons";
import { useTheme } from "@emotion/react";
import Flex from "../../../../UI/Flex/Flex";

const Item = styled.div(
  ({ theme }) => `
  margin-bottom: 10px;
  height: 46px;
  border-radius: 5px;
  background: ${theme.divider};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 18px;
  font-size: 12px;
`
);

export default function SettingsItem({
  item,
  isActive,
  applyGroup,
  setEditingGroup,
  loading,
  setDeletingGroup,
}) {
  const theme = useTheme();

  return (
    <Item isActive={isActive}>
      <div>
        <FontAwesomeIcon
          icon={faCheckCircle}
          style={{
            marginRight: 10,
            color: isActive ? theme.notification.successMain : null,
          }}
        />
        <span>{item.name}</span>
      </div>

      <Flex alignItems="center">
        <IOButton
          info
          icon={faPencil}
          style={{ width: 80, fontSize: 12, marginRight: 5 }}
          onClick={() => setEditingGroup(item.uuid)}
        >
          Edit
        </IOButton>
        <IOButton
          successDark
          icon={loading ? null : faPlay}
          style={{
            width: 80,
            fontSize: 12,
          }}
          onClick={() => applyGroup(item.uuid)}
          processing={loading}
        >
          Apply
        </IOButton>
        <FontAwesomeIcon
          icon={faTrashAlt}
          style={{
            marginLeft: 10,
            color: theme.notification.errorLight,
            cursor: "pointer",
          }}
          onClick={() => setDeletingGroup(item.uuid)}
        />
      </Flex>
    </Item>
  );
}
